<template>
  <section>
    <!-- Componentes externos -->
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Consulta de Items
    </h3>
    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton acutualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="listarServidores()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <!-- Filtros-->
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>
          <div class="filter-item">
            <v-text-field
              label="Nro item"
              type="number"
              v-model="form.nro_item"
              @input="filterNroItem"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Tipo movilidad"
              v-model="form.motivo"
              @input="filterMotivo"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="CI"
              v-model="form.ci"
              @input="filterCi"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Nombre"
              v-model="form.nombre_completo"
              @input="filterNombreCompleto"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Unidad"
              v-model="form.nombre_unidad"
              @input="filterNombreUnidad"
            ></v-text-field>
          </div>
          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                  }
                "
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          :items="lista_servidores"
          :headers="headers"
          class="elevation-1"
          :pagination.sync="pagination"
          :disable-initial-sort="true"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                id="cabecera_tabla"
                @click="changeSort(header.value)"
              >
                <v-icon small color="white">arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.nro_item }}</td>
            <td class="text-xs-center">{{ items.item.motivo }}</td>
            <td class="text-xs-center">{{ items.item.ci }}</td>
            <td class="text-xs-center">
              {{ items.item.nombre_completo }}
            </td>
            <td class="text-xs-center">
              {{ items.item.nombre_unidad }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import Filtros from "./mixins/Filtros"; // Componente de Aprobar Movilidad persona
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [Filtros],
  // Variables iniciales del componente
  data() {
    return {
      lista_servidores: [],
      loading: false,
      // Cabecera de la tabla
      headers: [
        { text: "Nro Item", value: "nro_item", align: "center" },
        { text: "Tipo movilidad", value: "motivo", align: "center" },
        { text: "CI", value: "ci", align: "center" },
        { text: "Nombre", value: "nombre_completo", align: "center" },
        { text: "Unidad", value: "nombre_unidad", align: "center" }
      ],
      pagination: {
        sortBy: ""
      },
      // Variables filtros
      filterShow: true,
      form: {},
      filters: {
        nro_item: "",
        motivo: "",
        ci: "",
        nombre_completo: "",
        nombre_unidad: ""
      }
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.listarServidores();
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async listarServidores() {
      try {
        this.loading = true;
        let res = await this.$service.graphql({
          query: `
					query{
            runQuery(consulta:"SELECT * FROM movilidad.v_lista_items_ministerio vlp where vlp.nro_item not in ('0') order by vlp.nro_item desc"){
              respuesta
            }
          }
            			`
        });
        //return res.persona.usuarios[0].correo;
        let lista_tmp = res.runQuery.respuesta;
        lista_tmp.forEach(element => {
          var datos_perosona = element.nombres.split("|");
          element.nombre_completo = datos_perosona[0];
          element.ci = datos_perosona[1];
          element.motivo = datos_perosona[2];
        });
        this.lista_servidores = lista_tmp;
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    }
  },
  // Definición de componentes importados
  components: {}
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
#cabecera_tabla {
  background: rgb(250, 252, 253);
  font-weight: bold;
  color: rgb(88, 85, 85);
}
.filtro {
  padding: 0;
  margin: 0;
  max-width: 100%;
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/ConsultaMovilidad.vue